import { Chip, Colors, Text } from 'library';
import { format12HourTime } from 'shared/Dates';
import React from 'react';
import { CenterInitiatedAppointmentTimeChangeRequest } from 'models';
import styled from 'styled-components';

const ColorsHashMap = {
    Pending: Colors.terraCotta,
    Accepted: Colors.turquoise,
    Declined: Colors.red,
};

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
});

const InnerContainer = styled.div({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
});

export default function CardRequestedTimeChange({
    timeChangeRequest,
}: {
    timeChangeRequest: CenterInitiatedAppointmentTimeChangeRequest;
}) {
    return (
        <Container>
            <Text variant="caption">You requested a time change:</Text>
            <InnerContainer>
                <Text variant="caption" bold>
                    {`${format12HourTime(new Date(timeChangeRequest.new_start_time))} - ${format12HourTime(
                        new Date(timeChangeRequest.new_end_time),
                    )}`}
                </Text>
                <Chip
                    label={timeChangeRequest.status}
                    backgroundColor={ColorsHashMap[timeChangeRequest.status]}
                    textColor={Colors.white}
                    style={{ minHeight: 10, maxHeight: 14, fontSize: 10 }}
                />
            </InnerContainer>
        </Container>
    );
}
